export default "__VITE_ASSET__1330095b__"